import {
  ReportListDataResTypes,
  ReportListDataParamsTypes,
} from './types';

import axiosInstance from 'services/common/instance';

export const getReportListDataService = async (
  params?: ReportListDataParamsTypes,
): Promise<ReportListDataResTypes> => {
  const res = await axiosInstance.get('ttpt-reports', { params });
  return res.data;
};

export const placeholder = '';
